module.exports = __webpack_public_path__ + "static/media/Recepción de materiales.f0239057.svg";